import { AddressType } from '../../types/AddressType';
import addressFormatter from './addressFormatter';

export default function streetAddress(address: Partial<AddressType>) {
  return addressFormatter(address, ['street1', 'street2']);
}
